import styled from 'styled-components';
import IconArrowDownCircle from './IconArrowDownCircle';
var IconArrowRightCircle = /*#__PURE__*/styled(IconArrowDownCircle).withConfig({
  displayName: "IconArrowRightCircle",
  componentId: "c11n-8-111-1__sc-zffocw-0"
})(["transform:rotate(270deg);"]);
export default IconArrowRightCircle;